module.exports = __webpack_public_path__ + "img/3_136.37fd9db5.png";